export const images = [
    { id:1, original: '/images/services/1/sub-categories/3/c1-s3-p1.jpg' },
]
